var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCog({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.06 14.6903C13.75 14.6903 15.12 13.3203 15.12 11.6303C15.12 9.94032 13.75 8.57031 12.06 8.57031C10.37 8.57031 9 9.94032 9 11.6303C9 13.3203 10.37 14.6903 12.06 14.6903Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7801 9.68C20.2166 9.72343 19.6523 9.60682 19.1522 9.3436C18.6521 9.08038 18.2366 8.68126 17.9534 8.1922C17.6702 7.70314 17.5309 7.14404 17.5515 6.57928C17.5722 6.01452 17.7519 5.46708 18.0701 5C17.1091 4.0915 15.9579 3.40831 14.7001 3C14.4555 3.50992 14.0718 3.94033 13.5932 4.24159C13.1146 4.54286 12.5606 4.70271 11.9951 4.70271C11.4295 4.70271 10.8755 4.54286 10.3969 4.24159C9.91831 3.94033 9.5346 3.50992 9.29005 3C8.03345 3.41104 6.88285 4.0939 5.92005 5C6.2375 5.46637 6.41701 6.0128 6.43798 6.57656C6.45895 7.14033 6.32053 7.69858 6.03861 8.18725C5.75669 8.67591 5.34269 9.07518 4.84414 9.33922C4.34559 9.60326 3.78269 9.72137 3.22005 9.68C2.92665 10.9634 2.92665 12.2966 3.22005 13.58C3.7811 13.5401 4.34207 13.6587 4.83894 13.9223C5.33581 14.1859 5.74857 14.5839 6.0301 15.0709C6.31163 15.5578 6.45059 16.1141 6.43113 16.6762C6.41167 17.2384 6.23458 17.7837 5.92005 18.25C6.88285 19.1561 8.03345 19.839 9.29005 20.25C9.5346 19.7401 9.91831 19.3097 10.3969 19.0084C10.8755 18.7071 11.4295 18.5473 11.9951 18.5473C12.5606 18.5473 13.1146 18.7071 13.5932 19.0084C14.0718 19.3097 14.4555 19.7401 14.7001 20.25C15.9579 19.8417 17.1091 19.1585 18.0701 18.25C17.7548 17.783 17.5775 17.2366 17.5584 16.6735C17.5393 16.1104 17.6791 15.5533 17.9619 15.0659C18.2447 14.5786 18.659 14.1808 19.1574 13.918C19.6558 13.6552 20.2182 13.538 20.7801 13.58C21.0735 12.2966 21.0735 10.9634 20.7801 9.68Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCog);
export default __webpack_public_path__ + "static/media/Cog.5b4d4972766543be553306793bc448f1.svg";
export { ForwardRef as ReactComponent };